import axios from 'axios';

let baseUrlWnq = "https://www.jxwnqwl.com/api"; //万年青的请求域名
// let baseUrlWnq1 = "https://test.jxwnqwl.com:8600/api"; //万年青的请求域名

export const getSignWnq = data => { return axios.get(`${baseUrlWnq}/wx/2/app/get/signature?url=` + data.url,) }; //万年青跳转app的配置
export const getOrderDetailsWnq = data => { return axios.post(`${baseUrlWnq}/tm/cargo/getCargoDetailByWeChatShareWt`, data) }; //万年青扫描货源二维码跳转app
